import { apiFetch } from './api.js'

const BASE = (import.meta.env.VITE_API_BASE ?? '') + '/mcp'

/** The MCP tool catalogue (server/mcp): every tool with its schema, control tools flagged adminOnly. */
export async function fetchMcpTools() {
  const r = await apiFetch(`${BASE}/tools`)
  if (!r.ok) throw new Error(`mcp tools ${r.status}`)
  return r.json()
}
